import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CipHeader from '../Components/CipHeader';
import cogoToast from 'cogo-toast';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import orderEntryService from '../services/order-entry-service';

const OrderEntryDashboard = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [responseObject, setResponseObject] = useState({
    eOrderTCG: 0,
    eBlister: 0,
    rphBlister: 0,
    facsLeft: 0,
    rphMachine: 0,
    facilityLeft: 0,
    bulkPending: 0,
    bulkVerify: 0,
    bulkTotal: 0,
    bulkTwoHr: 0,
    bulkThreeHr: 0,
    bulkFourHr: 0,
    fridgePending: 0,
    fridgeVerify: 0,
    fridgeTotal: 0,
    fridgeTwoHr: 0,
    fridgeThreeHr: 0,
    fridgeFourHr: 0,
    controlPending: 0,
    controlVerify: 0,
    controlTotal: 0,
    controlTwoHr: 0,
    controlThreeHr: 0,
    controlFourHr: 0,
    fastBulkPending: 0,
    fastBulkVerify: 0,
    fastBulkTotal: 0,
    fastBulkTwoHr: 0,
    fastBulkThreeHr: 0,
    fastBulkFourHr: 0,
    LCAPending: 0,
    LCAVerify: 0,
    LCATotal: 0,
    LCATwoHr: 0,
    LCAThreeHr: 0,
    LCAFourHr: 0,
    oneTouchPending: 0,
    oneTouchVerify: 0,
    oneTouchTotal: 0,
    oneTouchTwoHr: 0,
    oneTouchThreeHr: 0,
    oneTouchFourHr: 0,
    releaseMachinePending: 0,
    releaseMachineVerify: 0,
    releaseMachineTotal: 0,
    releaseMachineTwoHr: 0,
    releaseMachineThreeHr: 0,
    releaseMachineFourHr: 0,
    releaseNonMachinePending: 0,
    releaseNonMachineVerify: 0,
    releaseNonMachineTotal: 0,
    releaseNonMachineTwoHr: 0,
    releaseNonMachineThreeHr: 0,
    releaseNonMachineFourHr: 0,
    spePending: 0,
    speVerify: 0,
    speTotal: 0,
    speTwoHr: 0,
    speThreeHr: 0,
    speFourHr: 0,
    releaseTotal: 0,
    todayCount: 0,
    tomorrowVerifyTotal: 0,
    totalVolume: 0,
    totalNewOrders: 0,
    totalRefills: 0,
    fulFillmentVerify: 0
  }
  );
  const getOrderValues = async () => {
    try {
      setLoading(true);
      let resp = await orderEntryService.getOrderValues();
      setLoading(false);
      setResponseObject({
        eOrderTCG: resp.eoTCG,
        eBlister: resp.eoBlister,
        rphBlister: resp.rphBlister,
        rphMachine: resp.rphMachine,
        facsLeft: resp.facsLeft,
        bulkPending: resp.bulk.pending,
        bulkVerify: resp.bulk.verify,
        bulkTotal: resp.bulk.total,
        bulkTwoHr: resp.bulk.gt2,
        bulkThreeHr: resp.bulk.gt3,
        bulkFourHr: resp.bulk.gt4,
        fridgePending: resp.fridge.pending,
        fridgeVerify: resp.fridge.verify,
        fridgeTotal: resp.fridge.total,
        fridgeTwoHr: resp.fridge.gt2,
        fridgeThreeHr: resp.fridge.gt3,
        fridgeFourHr: resp.fridge.gt4,
        controlPending: resp.controlRoom.pending,
        controlVerify: resp.controlRoom.verify,
        controlTotal: resp.controlRoom.total,
        controlTwoHr: resp.controlRoom.gt2,
        controlThreeHr: resp.controlRoom.gt3,
        controlFourHr: resp.controlRoom.gt4,
        fastBulkPending: resp.fastBulk.pending,
        fastBulkVerify: resp.fastBulk.verify,
        fastBulkTotal: resp.fastBulk.total,
        fastBulkTwoHr: resp.fastBulk.gt2,
        fastBulkThreeHr: resp.fastBulk.gt3,
        fastBulkFourHr: resp.fastBulk.gt4,
        LCAPending: resp.lca.pending,
        LCAVerify: resp.lca.verify,
        LCATotal: resp.lca.total,
        LCATwoHr: resp.lca.gt2,
        LCAThreeHr: resp.lca.gt3,
        LCAFourHr: resp.lca.gt4,
        oneTouchPending: resp.oneTouch.pending,
        oneTouchVerify: resp.oneTouch.verify,
        oneTouchTotal: resp.oneTouch.total,
        oneTouchTwoHr: resp.oneTouch.gt2,
        oneTouchThreeHr: resp.oneTouch.gt3,
        oneTouchFourHr: resp.oneTouch.gt4,
        releaseMachinePending: resp.releaseMachine.pending,
        releaseMachineVerify: resp.releaseMachine.verify,
        releaseMachineTotal: resp.releaseMachine.total,
        releaseMachineTwoHr: resp.releaseMachine.gt2,
        releaseMachineThreeHr: resp.releaseMachine.gt3,
        releaseMachineFourHr: resp.releaseMachine.gt4,
        releaseNonMachinePending: resp.releaseNonMachine.pending,
        releaseNonMachineVerify: resp.releaseNonMachine.verify,
        releaseNonMachineTotal: resp.releaseNonMachine.total,
        releaseNonMachineTwoHr: resp.releaseNonMachine.gt2,
        releaseNonMachineThreeHr: resp.releaseNonMachine.gt3,
        releaseNonMachineFourHr: resp.releaseNonMachine.gt4,
        spePending: resp.specials.pending,
        speVerify: resp.specials.verify,
        speTotal: resp.specials.total,
        speTwoHr: resp.specials.gt2,
        speThreeHr: resp.specials.gt3,
        speFourHr: resp.specials.gt4,
        releaseTotal: resp.releases,
        todayCount: resp.todayCount,
        tomorrowVerifyTotal: resp.tomorrowVerifyTotal,
        totalVolume: resp.totalVolume,
        totalNewOrders: resp.totalNewOrders,
        totalRefills: resp.totalRefills,
        fulFillmentVerify: resp.bulk.verify + resp.fridge.verify + resp.controlRoom.verify +
          resp.fastBulk.verify + resp.lca.verify + resp.oneTouch.verify +
          resp.releaseMachine.verify + resp.releaseNonMachine.verify + resp.specials.verify
      })
    } catch (e) {
      const { hide } = cogoToast.error('Error retrieving details. Please contact administrator.', {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      setLoading(false);
    }
  };
  useEffect(() => {
    getOrderValues();
    setInterval(function () { getOrderValues(); }, 300000);
  }, []);
  return (
    <>
      <CipHeader />
      <div className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"}`}>
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div className="bg-white w-11/12 sm:w-10/12 mx-auto mt-12">
        <div className="text-sm">
          <div className="container px-6 mx-auto grid pb-4">
            <h2 className="my-6 text-base font-semibold text-gray-700 dark:text-gray-200">ORDER ENTRY-FULFILLMENT DASHBOARD</h2>
            <div>
              <div className="flex items-center justify-between p-4 mb-2 text-sm font-semibold text-purple-100 bg-purple-600 bg-purple-600 rounded-lg shadow-md focus:outline-none focus:shadow-outline-purple">
                <span>ORDER ENTRY</span>
              </div>
              <div className="w-full overflow-hidden rounded-lg shadow mt-4 py-4 px-2">
                <div>
                  <span className="w-1/5 inline-block">
                    <div className="w-11/12 bg-odr_tcg rounded-lg p-4">
                      <div>
                        <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">E-Order TCG</p>
                        <p className="text-lg font-semibold text-gray-700 dark:text-gray-200 EorderTcg">{responseObject.eOrderTCG}</p>
                      </div>
                    </div>
                  </span>
                  <span className="w-1/5 inline-block">
                    <div className="w-11/12 bg-rph_reviewer rounded-lg p-4">
                      <div>
                        <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">RPH Review TCG</p>
                        <p className="text-lg font-semibold text-gray-700 dark:text-gray-200 EorderTcg">{responseObject.rphMachine}</p>
                      </div>
                    </div>
                  </span>
                  <span className="w-1/5 inline-block">
                    <div className="w-11/12 bg-odr_blister rounded-lg p-4">
                      <div>
                        <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">E-Order Blister</p>
                        <p className="text-lg font-semibold text-gray-700 dark:text-gray-200 EorderTcg">{responseObject.eBlister}</p>
                      </div>
                    </div>
                  </span>
                  <span className="w-1/5 inline-block">
                    <div className="w-11/12 bg-rph_blister rounded-lg p-4">
                      <div>
                        <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">RPH Review Blister</p>
                        <p className="text-lg font-semibold text-gray-700 dark:text-gray-200 EorderTcg">{responseObject.rphBlister}</p>
                      </div>
                    </div>
                  </span>
                  <span className="w-1/5 inline-block">
                    <div className="w-11/12 bg-facilityLeft rounded-lg p-4">
                      <div>
                        <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">Facilities Left</p>
                        <p className="text-lg font-semibold text-gray-700 dark:text-gray-200 EorderTcg">{responseObject.facsLeft}</p>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white w-11/12 sm:w-10/12 mx-auto mt-4">
        <div className="pb-5 text-sm">
          <div className="container px-6 mx-auto grid">
            <div className="flex items-center justify-between p-4 mb-2 text-sm font-semibold text-purple-100 bg-purple-600 bg-purple-600 rounded-lg shadow-md focus:outline-none focus:shadow-outline-purple mt-4">
              <span>FULFILLMENT</span>
            </div>
            <div className="w-full overflow-hidden rounded-lg shadow mt-2">
              <div className="w-full overflow-x-auto">
                <table className="w-full whitespace-no-wrap">
                  <thead>
                    <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                      <th className="px-4 py-3">Area</th>
                      <th className="px-4 py-3 text-center bg-orderVerified">To Verify ({responseObject.fulFillmentVerify})</th>
                      <th className="px-4 py-3 text-center bg-orderTwohr">&gt; 2 Hrs</th>
                      <th className="px-4 py-3 text-center bg-orderThreehr">&gt; 3 Hrs</th>
                      <th className="px-4 py-3 text-center bg-orderFourhr">&gt; 4 Hrs</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">BULK</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.bulkVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.bulkTwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.bulkThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.bulkFourHr}</td>
                    </tr>
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">FRIDGE</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.fridgeVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.fridgeTwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.fridgeThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.fridgeFourHr}</td>
                    </tr>
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">CONTROL ROOM</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.controlVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.controlTwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.controlThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.controlFourHr}</td>

                    </tr>
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">FASTBULK</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.fastBulkVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.fastBulkTwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.fastBulkThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.fastBulkFourHr}</td>

                    </tr>
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">LCA</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.LCAVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.LCATwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.LCAThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.LCAFourHr}</td>
                    </tr>
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">ONETOUCH</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.oneTouchVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.oneTouchTwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.oneTouchThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.oneTouchFourHr}</td>
                    </tr>
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">RELEASE MACHINE</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.releaseMachineVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.releaseMachineTwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.releaseMachineThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.releaseMachineFourHr}</td>
                    </tr>
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">RELEASE NON MACHINE</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.releaseNonMachineVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.releaseNonMachineTwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.releaseNonMachineThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.releaseNonMachineFourHr}</td>
                    </tr>
                    <tr className="text-gray-700 dark:text-gray-400">
                      <td className="px-4 py-3">
                        <div className="flex items-center text-sm">
                          <div className="text-xs text-gray-600 dark:text-gray-400">SPECIALS</div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.speVerify}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.speTwoHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.speThreeHr}</td>
                      <td className="px-4 py-3 text-sm text-center">{responseObject.speFourHr}</td>
                    </tr>
                  </tbody>
                </table>


              </div>
            </div>
            <div className="w-full overflow-hidden rounded-lg shadow mt-4 py-4 px-2">
              <div>
                <span className="w-1/4 inline-block">
                  <div className="w-11/12">
                    <div className="py-4 px-4 text-center font-bold bg-orderTotalCount rounded-tl-lg rounded-tr-lg h-24">
                      <span className=""><img src="/img/todayCount.svg" alt="" className="w-8 h-8 m-auto" /></span>
                      <span className="align-top m-2 ">TODAY'S COUNT</span>
                    </div>
                    <div className="py-4 px-4 text-center font-bold border">{responseObject.todayCount}</div>
                  </div>
                </span>
                <span className="w-1/4 inline-block">
                  <div className="w-11/12">
                    <div className="py-4 px-4 text-center font-bold bg-totalVolume rounded-tl-lg rounded-tr-lg h-24">
                      <span className=""><img src="/img/totalVolume.svg" alt="" className="w-8 h-8 m-auto" /></span>
                      <span className="align-top m-2 ">TOMORROW'S VERIFY TOTAL</span>
                    </div>
                    <div className="py-4 px-4 text-center font-bold border">{responseObject.tomorrowVerifyTotal}</div>
                  </div>
                </span>
                <span className="w-1/4 inline-block">
                  <div className="w-11/12">
                    <div className="py-4 px-4 text-center font-bold bg-totalNewOrder rounded-tl-lg rounded-tr-lg h-24">
                      <span className=""><img src="/img/totalNewOrders.svg" alt="" className="w-8 h-8 m-auto" /></span>
                      <span className="align-top m-2 ">TOTAL NEW ORDERS</span>
                    </div>
                    <div className="py-4 px-4 text-center font-bold border">{responseObject.totalNewOrders}</div>
                  </div>
                </span>
                <span className="w-1/4 inline-block">
                  <div className="w-11/12">
                    <div className="py-4 px-4 text-center font-bold bg-totalRefills rounded-tl-lg rounded-tr-lg h-24">
                      <span className=""><img src="/img/totalRefills.svg" alt="" className="w-8 h-8 m-auto" /></span>
                      <span className="align-top m-2 ">TOTAL REFILLS/STOCK</span>
                    </div>
                    <div className="py-4 px-4 text-center font-bold border">{responseObject.totalRefills}</div>
                  </div>
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    },
  )(OrderEntryDashboard),
);